module.exports = __webpack_public_path__ + "static/media/alankar-logistics.9b3ebc43.png";